import { useTranslation } from 'next-i18next/pages';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useUserData } from '@/hooks/useUserData';

import { TextInput } from '../../TextInput/TextInput';

export const FirstNameInput = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const { userData, isSignedInAndUserDataNotLoaded } = useUserData();

  if (isSignedInAndUserDataNotLoaded) return null;

  return (
    <TextInput
      defaultValue={userData?.firstName}
      label={t('search.contact.form.label.firstName')}
      name="firstName"
      type="text"
      autoComplete="given-name"
      isRequired
      validationMessages={{
        valueMissing: t('search.contact.form.validation.firstName.required'),
      }}
    />
  );
};
